import { pedidosInitialState } from '../initialState/pedidos';

const pedidosReducer = (state = pedidosInitialState, { type, payload }) => {
  switch (type) {
    case 'PEDIDO_LAVANDARIA':
      return {
        ...state,
        pedidoLavandaria: payload,
      };

    default:
      return state;
  }
};

export default pedidosReducer;
